import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-nested-table',
  templateUrl: './nested-table.component.html',
  styleUrls: ['./nested-table.component.scss'],
})
export class NestedTableComponent implements OnInit {
  @Input() dataSource;

  @Input() tableConfig;

  @Input() displayedColumns;

  constructor() {}

  ngOnInit(): void {}
}
